import { render, staticRenderFns } from "./AccountResetConfirm.vue?vue&type=template&id=304e9e42"
import script from "./AccountResetConfirm.vue?vue&type=script&lang=js"
export * from "./AccountResetConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports